import { MessageDescriptor } from '@formatjs/intl';
import { genericMessages } from '../generic.i18n';
import { useCallback } from 'react';
import { useIntl } from 'react-intl';

export type IntlMessage =
	| Record<string, MessageDescriptor>
	| Array<Record<string, MessageDescriptor>>;

export const useIntlMessage = (additionalMessages?: IntlMessage) => {
	const intl = useIntl();

	const getMessage = useCallback(
		(text?: string) => {
			if (typeof text === 'undefined') {
				return intl.formatMessage(genericMessages.invalid_text);
			}
			if (typeof text !== 'string') {
				return text;
			}
			const textLower = text.toLowerCase();
			const labelMessage = text
				? Array.isArray(additionalMessages)
					? additionalMessages?.find((messages) => messages[textLower])
					: additionalMessages?.[textLower] ??
					  genericMessages[textLower as keyof typeof genericMessages]
				: undefined;
			if (labelMessage) {
				return intl.formatMessage(labelMessage);
			} else {
				return text;
			}
		},
		[intl, additionalMessages]
	);

	return getMessage;
};
